import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function ImagePickerOverlay({ onSelect, onClose }) {
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchImages() {
      const { data } = await supabase
        .from('image_assets')
        .select('*')
        .order('created_at', { ascending: false })
      setImages(data || [])
      setLoading(false)
    }
    fetchImages()
  }, [])

  return (
    <div className="image-picker-overlay" onClick={onClose}>
      <div className="image-picker-panel" onClick={e => e.stopPropagation()}>
        <div className="image-picker-header">
          <span className="editor-label" style={{ fontSize: 'calc(0.8rem * var(--scale))' }}>Select image</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        {loading && <div className="loading" style={{ padding: '1rem' }}>Loading…</div>}
        {!loading && images.length === 0 && (
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: 'calc(0.72rem * var(--scale))', color: 'var(--mid)', padding: '1rem' }}>
            No images yet — upload some in Image Manager.
          </p>
        )}
        <div className="image-picker-grid">
          {images.map(image => (
            <div key={image.id} className="image-picker-item" onClick={() => onSelect(image)}
              title={image.caption || image.filename}>
              <img src={image.public_url} alt={image.caption || ''} className="image-picker-thumb" />
              {image.caption && (
                <p className="image-picker-caption">{image.caption}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
